import { render, staticRenderFns } from "./conversations.vue?vue&type=template&id=ebd05314&scoped=true&"
import script from "./conversations.vue?vue&type=script&lang=js&"
export * from "./conversations.vue?vue&type=script&lang=js&"
import style0 from "./conversations.vue?vue&type=style&index=0&id=ebd05314&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd05314",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebd05314')) {
      api.createRecord('ebd05314', component.options)
    } else {
      api.reload('ebd05314', component.options)
    }
    module.hot.accept("./conversations.vue?vue&type=template&id=ebd05314&scoped=true&", function () {
      api.rerender('ebd05314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/conversations/conversations.vue"
export default component.exports